import { Box, Grid, Stack, useTheme } from "@mui/material";
import blogDataList from '../../../data/blogs/en/blogs.json';
import BlogDetailsBox from "../../blog/blog-details-box";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Title3 from '../../../components/title/title3';
import CustomButton from '../../../components/form/custom-button';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useNavigate } from "react-router-dom";

const blogsLocales = "blogs.home";

const BlogsLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    const [blogData, setBlogData] = useState([]);

    useEffect(() => {
        if(blogDataList.length > 0){
            let indexList = [];

            for(let i = 0; i < blogDataList.length; i++){
                indexList.push(i);
            }

            for(let i = 0; i < indexList.length; i++){
                let temp = indexList[i];
                let randomIndex = Math.floor(Math.random() * (indexList.length - 0));

                indexList[i] = indexList[randomIndex];
                indexList[randomIndex] = temp;
            }

            if(indexList.length >= 3) setBlogData(indexList.splice(0, 3));
            else setBlogData(indexList);
        }
    }, []);

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pb: {xs: 3, md: 5},
                    display: blogDataList.length > 0 ? 'flex' : 'none'
                }}
                className="bodySideMargin1 sectionDoubleSpacing"
            >
                <Stack
                    direction='column'
                    width='100%'
                >
                    <Grid
                        direction='row'
                        alignItems='end'
                        container
                        spacing={{xs: 2, md: 5}}
                    >
                        <Grid
                            size={{xs: 12, md: 8}}
                        >
                            <Title3 
                                title={t(`${blogsLocales}.title`)}
                                description={t(`${blogsLocales}.description`)}
                            />
                        </Grid>

                        <Grid
                            size={{xs: 12, md: 4}}
                            direction='row'
                            display={{xs: 'none', md: 'flex'}}
                            justifyContent={{xs: 'center', md: 'end'}}
                        >
                            <CustomButton 
                                label={t(`${blogsLocales}.action`)}
                                onClick={() => navigate('/blog')}
                                endIcon={<KeyboardArrowRightIcon />}
                                needAnimation
                            />
                        </Grid>        
                    </Grid>

                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='start'
                        container
                        spacing={{xs: 2, md: 5}}
                        width='100%'
                        sx={{
                            pt: {xs: 0, md: 5}
                        }}
                    >
                        {
                            blogData.map((item, index) => {
                                return <Grid
                                    key={index}
                                    size={{xs: 12, md: 6, lg: 4}}
                                >
                                    <BlogDetailsBox 
                                        index={index}
                                        img={blogDataList[item].image}
                                        title={blogDataList[item].title}
                                        description={blogDataList[item].description}
                                        link={`/blog/${index + 1}`}
                                    />
                                </Grid>
                            })
                        }
                    </Grid>

                    <Stack
                        direction='row'
                        justifyContent='center'
                        display={{xs: 'flex', md: 'none'}}
                        sx={{
                            pt: {xs: 5, md: 0}
                        }}
                    >
                        <CustomButton 
                            label={t(`${blogsLocales}.action`)}
                            onClick={() => navigate('/blog')}
                            endIcon={<KeyboardArrowRightIcon />}
                            needAnimation
                        />
                    </Stack>
                </Stack>
            </Box>
        </>
    );
}

export default BlogsLayout;